// extracted by mini-css-extract-plugin
export default {"selector":"styles_selector__mGu1J","offsetBottom":"styles_offsetBottom__1TM3B"};